import { setEnvironment, PlatformType } from '@altermaind/core/env';
import packageJson from '../../../package.json';

export type Environment = {
  [key: string]: string;
};

/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-explicit-any */
const injectedEnv = (typeof window !== 'undefined' && (window as any)._env_) || {};

export const environment: Environment = { ...process.env, ...injectedEnv };

export function configureEnv(): void {
  setEnvironment({
    host: {
      base: environment.VITE_APP_HOST_API_BASE || '',
      onb: '',
      env: environment.VITE_APP_ENV || '',
    },
    platform: PlatformType.web,
    platformVersion: 0,
    buildNumber: '',
    version: packageJson.version,
    clientId: environment.VITE_APP_OAUTH_CLIENT_ID || '',
    appName: 'onboarding-retail' as never,
  });
}
